document.addEventListener('DOMContentLoaded', () => {
	if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
		gsap.registerPlugin(ScrollTrigger);
	}

	document.querySelectorAll('.feature-cards-section').forEach((section) => {
		initFeatureCardsLifecycle(section);
	});
});

/**
 * Manages the lifecycle of desktop GSAP vs mobile Swiper,
 * destroying/re-initializing on resize breakpoints.
 */
function initFeatureCardsLifecycle(section) {
	let isDesktop = window.innerWidth >= 1024;
	let desktopAnimationTl = null;
	let desktopScrollTrigger = null;
	let swiperInstance = null;

	function init() {
		if (isDesktop) {
			// Clean up mobile
			if (swiperInstance) {
				swiperInstance.destroy(true, true);
				swiperInstance = null;
			}
			initDesktop();
		} else {
			// Clean up desktop
			if (desktopAnimationTl) {
				desktopAnimationTl.kill();
				desktopAnimationTl = null;
			}
			if (desktopScrollTrigger) {
				desktopScrollTrigger.kill();
				desktopScrollTrigger = null;
			}
			// Reset any inline styles left by GSAP
			if (typeof gsap !== 'undefined') {
				gsap.set(section.querySelectorAll('.fcs-img, .fcs-desc'), {
					clearProps: 'all',
				});
			}
			initMobile();
		}
	}

	function initDesktop() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
			return;

		const scrollArea = section.querySelector('.fcs-scroll-area');
		const images = gsap.utils.toArray(section.querySelectorAll('.fcs-img'));
		const descs = gsap.utils.toArray(section.querySelectorAll('.fcs-desc'));
		const count = Math.max(images.length, descs.length);

		if (!scrollArea || count <= 1) return;

		// Create a paused timeline with clear labels for each card state
		desktopAnimationTl = gsap.timeline({ paused: true });

		// Initial state label
		desktopAnimationTl.addLabel('card-0');

		for (let i = 0; i < count - 1; i++) {
			const transitionDuration = 0.6;
			const label = `card-${i + 1}`;

			desktopAnimationTl
				// Current image moves out
				.to(
					images[i],
					{
						y: '-100%',
						duration: transitionDuration,
						ease: 'power2.inOut',
					},
					`transition-${i}`
				)
				// Next image moves in
				.fromTo(
					images[i + 1],
					{ y: '100%' },
					{
						y: '0%',
						duration: transitionDuration,
						ease: 'power2.inOut',
					},
					'<'
				)
				// Current description fades out
				.to(
					descs[i],
					{
						opacity: 0,
						y: -30,
						duration: transitionDuration,
						ease: 'power2.inOut',
					},
					'<'
				)
				// Next description fades in
				.fromTo(
					descs[i + 1],
					{ opacity: 0, y: 30 },
					{
						opacity: 1,
						y: 0,
						duration: transitionDuration,
						ease: 'power2.inOut',
					},
					'<'
				)
				.addLabel(label);
		}

		// Set initial positions for all images/descs except the first one
		gsap.set(images.slice(1), { y: '100%' });
		gsap.set(descs.slice(1), { opacity: 0, y: 30 });

		let currentIndex = 0;

		// Use a single ScrollTrigger to monitor progress and trigger discrete transitions
		desktopScrollTrigger = ScrollTrigger.create({
			trigger: scrollArea,
			start: 'top top',
			end: 'bottom bottom',
			onUpdate: (self) => {
				const progress = self.progress;
				// The scroll distance is (count - 1) * 100vh.
				// We want to trigger transitions at 100vh intervals.
				let index = Math.round(progress * (count - 1));

				if (index !== currentIndex) {
					desktopAnimationTl.tweenTo(`card-${index}`, {
						duration: 0.6,
						ease: 'power2.inOut',
					});
					currentIndex = index;
				}
			},
		});
	}

	function initMobile() {
		const el = section.querySelector('.mobile-cards-slider');
		if (!el || typeof Swiper === 'undefined' || swiperInstance) return;

		swiperInstance = new Swiper(el, {
			slidesPerView: 1,
			spaceBetween: 24,
			grabCursor: true,
			pagination: {
				el: el.querySelector('.swiper-pagination'),
				clickable: true,
			},
		});
	}

	// Initialize on load
	init();

	// Listen to resize
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			const newIsDesktop = window.innerWidth >= 1024;
			if (newIsDesktop !== isDesktop) {
				isDesktop = newIsDesktop;
				init(); // Re-trigger init only when breakpoint is crossed
			}
		}, 200); // 200ms debounce
	});
}
